import { setBaseUrl, getAxios } from "@repo/rq-api-public";
import { isAuthenticatedAtom } from "../components/store";
import { jotaiStore } from "../components/store";
import { ACCESS_TOKEN } from "../utils/token";

const baseUrl = import.meta.env.VITE_API_PROXY_HOST
  ? "/api"
  : import.meta.env.VITE_API_HOST;
setBaseUrl(baseUrl);

const axios = getAxios();

const PLATFORM_KEY = "platformKey";

function getApiKey(): string | undefined {
  const fromUrl = new URLSearchParams(window.location.search).get(PLATFORM_KEY);
  if (fromUrl) {
    localStorage.setItem(PLATFORM_KEY, fromUrl);
    return fromUrl;
  }

  return localStorage.getItem(PLATFORM_KEY) ?? import.meta.env.VITE_API_KEY;
}

axios.interceptors.request.use(
  (config) => {
    config.headers.ApiKey = getApiKey();

    const authToken = localStorage.getItem(ACCESS_TOKEN);
    if (authToken) {
      config.headers.Authorization = `Bearer ${authToken}`;
    }

    return config;
  },
  (error) => Promise.reject(error),
);

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem(ACCESS_TOKEN);
      jotaiStore.set(isAuthenticatedAtom, false);
    }
    return Promise.reject(error);
  },
);
